import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      borderLeft: '1px solid var(--x-bg-8)',
      display: 'none',
      marginInlineStart: 20,
      paddingInlineStart: 20,
    },

    container: {
      display: 'none',
    },

    list: {
      display: 'grid',
      listStyleType: 'none',
      gridAutoFlow: 'column',
      gap: 8,
    },

    visible: {
      display: 'block',
    },

    bottomLinks: {
      marginInlineStart: 16,
      marginBlockStart: 12,
    },
  }),
  { name: 'DropdownSubmenu' },
);

export default useStyles;
